export const HEADERS = [
	'No.',
	'Start at',
	'End at',
	'Consultant',
	'Status',
	'Email',
	'Phone number',
	'Name',
	'Actions',
];
